"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgFlag02 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M5 2a1 1 0 0 0-2 0v20a1 1 0 1 0 2 0v-6.462a3.32 3.32 0 0 1 .246-.11C5.741 15.232 6.613 15 8 15c1.28 0 2.36.421 3.629.928l.055.023C12.904 16.439 14.307 17 16 17c1.613 0 2.74-.27 3.496-.572.377-.15.658-.308.856-.44.098-.066.176-.125.235-.173.041-.034.081-.07.12-.107a.997.997 0 0 0 .293-.709V4a1 1 0 0 0-1.685-.729.96.96 0 0 1-.073.053c-.083.056-.24.148-.488.248C18.259 3.769 17.387 4 16 4c-1.28 0-2.36-.421-3.629-.928l-.055-.023C11.096 2.561 9.693 2 8 2c-1.292 0-2.272.173-3 .397V2Z", fill: "currentColor" }) }))); };
exports.default = SvgFlag02;
